import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Tr3Module } from '@trilean/tr3';
import { ExpandableFilterComponent } from './components/expandable-filter/expandable-filter.component';
import { ExpandableSearchComponent } from './components/expandable-search/expandable-search.component';
import { PasswordEditComponent } from './components/password-edit/password-edit.component';
import { SparklineComponent } from './components/sparkline/sparkline.component';
import { DataDisplayComponent } from './components/data-display/data-display.component';
import { MediaQueryClassesDirective } from './directives/media-query-classes.directive';
import { MatIconFontToSvgDirective } from './directives/mat-icon-font-to-svg.directive';
import { MatTableStaticDirective } from './directives/mat-table-static.directive';
import { CdkPortalValue } from './directives/cdk-portal-value.directive';

@NgModule({
  declarations: [
    ExpandableSearchComponent,
    ExpandableFilterComponent,
    PasswordEditComponent,
    SparklineComponent,
    DataDisplayComponent,
    MediaQueryClassesDirective,
    MatIconFontToSvgDirective,
    MatTableStaticDirective,
    CdkPortalValue,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    Tr3Module,
  ],
  exports: [
    ExpandableSearchComponent,
    ExpandableFilterComponent,
    PasswordEditComponent,
    SparklineComponent,
    DataDisplayComponent,
    MediaQueryClassesDirective,
    MatIconFontToSvgDirective,
    MatTableStaticDirective,
    CdkPortalValue,
  ],
})
export class Tr3MaterialModule {}
